import { environment } from "@environment/environment";

const clog = (...args: unknown[]): void => {
  if (environment.environment !== "prod") {
    console.log(...args);
  }
};

export default clog;
